// DOC https://cli.vuejs.org/config/#pages
// PRODUCTION https://cli.vuejs.org/guide/deployment.html

const config = require('./config/env.config');

const setHeadTags = (page, tag) => {
    return config[page].headful[tag];
}

const outputDir = 'data';

module.exports = {

    // baseUrl: process.env.NODE_ENV === 'production' ? `/BDAgency/${config.lang}/dist/` : '/',
    baseUrl: process.env.NODE_ENV === 'production' ? `/${config.lang}/${outputDir}/` : '/',

    // assetsDir: '1',
    
    outputDir: outputDir,

    pages: {
        index: {
            // entry for the page
            entry: 'src/main.js',
            // the source template
            template: 'public/index.html',
            // output as dist/index.html
            filename: 'index.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: {
                titlePage: setHeadTags('INDEX', 'title'),
                meta: {
                    description: setHeadTags('INDEX', 'description')
                },
                htmlAttrLang: config.lang
            },
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'index']
        },
        about: {
            // entry for the page
            entry: 'src/about/main.js',
            // the source template
            template: 'public/about.html',
            // output as dist/about.html
            filename: 'about.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: {
                titlePage: setHeadTags('ABOUT', 'title'),
                meta: {
                    description: setHeadTags('ABOUT', 'description')
                },
                htmlAttrLang: config.lang
            },
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'about']
        },
        vision: {
            // entry for the page
            entry: 'src/vision/main.js',
            // the source template
            template: 'public/vision.html',
            // output as dist/vision.html
            filename: 'vision.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: {
                titlePage: setHeadTags('VISION', 'title'),
                meta: {
                    description: setHeadTags('VISION', 'description')
                },
                htmlAttrLang: config.lang
            },
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'vision']
        },
        career: {
            // entry for the page
            entry: 'src/career/main.js',
            // the source template
            template: 'public/career.html',
            // output as dist/career.html
            filename: 'career.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: {
                titlePage: setHeadTags('CAREER', 'title'),
                meta: {
                    description: setHeadTags('CAREER', 'description')
                },
                htmlAttrLang: config.lang
            },
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'career']
        },
        contacts: {
            // entry for the page
            entry: 'src/contacts/main.js',
            // the source template
            template: 'public/contacts.html',
            // output as dist/contacts.html
            filename: 'contacts.html',
            // when using title option,
            // template title tag needs to be <title><%= htmlWebpackPlugin.options.title %></title>
            title: {
                titlePage: setHeadTags('CONTACTS', 'title'),
                meta: {
                    description: setHeadTags('CONTACTS', 'description')
                },
                htmlAttrLang: config.lang
            },
            // chunks to include on this page, by default includes
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'contacts']
        },
        notFound: {
            // entry for the page
            entry: 'src/notFound/main.js',
            // the source template
            template: 'public/notFound.html',
            // output as dist/contacts.html
            filename: 'notFound.html',
            // extracted common chunks and vendor chunks.
            chunks: ['chunk-vendors', 'chunk-common', 'notFound']
        },
    }

}